<script>
    export let fill = 'var(--accent)'
    export let width = '32px'
</script>

<svg version="1.1" x="0px" y="0px" viewBox="0 0 168.594 168.594" style="fill: {fill}; width: {width}">
    <g>
	<path d="M84.297,0c-2.463,0-4.77,1.21-6.17,3.237C72.75,11.021,25.6,80.144,25.6,109.899c0.002,32.364,26.334,58.694,58.697,58.694
		c32.365,0,58.697-26.331,58.697-58.695c0-29.755-47.15-98.877-52.525-106.661C89.068,1.21,86.762,0,84.297,0z M84.297,153.594
		c-24.092,0-43.695-19.602-43.697-43.695c0-18.587,27.51-64.32,43.697-88.954c16.189,24.634,43.697,70.367,43.697,88.954
		C127.994,133.992,108.391,153.594,84.297,153.594z"/>
    </g>
    <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
</svg>

<style>
svg {
    cursor: pointer;
}
</style>